import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { WebappService } from '../../services/webapp.service';
import { AppService } from './../../services/app.service';

@Component({
  selector: 'mobo-nav',
  templateUrl: './nav.component.html',
  styles: [],
})
export class NavComponent implements OnInit {
  public baseUrl = environment.baseUrl;
  public cities!: any;
  public selectedCity!: any;

  constructor(
    public webappService: WebappService,
    public appService: AppService
  ) {}

  ngOnInit() {
    this.getCities();
    this.watchCity();
  }

  async getCities() {
    this.cities = await this.webappService.getCities();
  }

  public changeCity(city: any) {
    this.webappService.selectedCity.next(city.id);
  }

  watchCity() {
    this.webappService.selectedCity.subscribe((cityId) => {
      this.selectedCity = cityId;
    });
  }
}
